import {
  Component,
  ViewChildren,
  AfterViewInit,
  QueryList,
  OnDestroy,
  Input,
  OnInit
} from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { CookieService } from 'angular2-cookie/core';

import { UserPricingView } from '../../model/user-pricing-view';
import { CurrentUser } from '../../model/current-user';
import { Quote } from '../../model/quote';
import { QuoteRevision } from '../../model/quote-revision';

import { PageTitleService } from '../../services/page-title.service';
import { CurrentUserService } from '../../services/current-user.service';
import { AuthDataService } from '../../services/auth-data.service';
import { ApplicationStateService } from '../../services/application-state.service';
import { QuoteInfoService } from '../../services/quote-info.service';
import { UserPricingViewService } from '../../services/user-pricing-view.service';
import { QuoteService } from '../../services/quote.service';
import { AuditHistoryService } from '../../services/audit-history.service';
import { BrowserWidthService } from '../../services/browser-width.service';
import { QuoteRevisionInfoService } from '../../services/quote-revision-info.service';

@Component({
  selector: 'yeti-title-bar',
  template: require('./yeti-title-bar.component.html'),
  styles: [require('./yeti-title-bar.component.scss')]
})
export class YetiTitleBarComponent implements AfterViewInit, OnDestroy, OnInit {
  @ViewChildren('searchBox')
  public searchBox: QueryList<any>;
  pageTitle: any = { title: '', subTitle: '' };
  search: Observable<any>;
  currentUser: CurrentUser;
  quoteRevisions: QuoteRevision[];

  searchTerm: string;
  cmhBaseUrl: string;
  mchBaseUrl: string;

  quoteId: number;
  modelId: number;

  userModalState: boolean = false;
  hideAdmin: boolean;
  hideOptionsAdmin: boolean;
  hideApprovals: boolean;
  subscription: Subscription = new Subscription();

  constructor(
    public pageTitleService: PageTitleService,
    public currentUserService: CurrentUserService,
    public authDataService: AuthDataService,
    public applicationStateService: ApplicationStateService,
    public quoteInfoService: QuoteInfoService,
    public quoteRevisionInfoService: QuoteRevisionInfoService,
    public cookieService: CookieService,
    public router: Router,
    public userPricingViewService: UserPricingViewService,
    public quoteService: QuoteService,
    public auditHistoryService: AuditHistoryService,
    public browserWidthService: BrowserWidthService
  ) {
    const pageTitleSub = this.pageTitleService.pageTitle.subscribe(
      x => (this.pageTitle = x)
    );
    this.subscription.add(pageTitleSub);
    this.cmhBaseUrl = this.cookieService.get('cmhBaseUrl');
    this.mchBaseUrl = this.cookieService.get('mchBaseUrl');

    const currentUserSub = this.currentUserService.currentUser$.subscribe(
      cu => {
        this.currentUser = cu;
        this.hideAdmin =
          cu.roles.includes('Rtl_Admin') && !cu.isPlantUser ? false : true;
        this.hideOptionsAdmin = cu.roles.includes('MyCustomHomes_Admin')
          ? false
          : true;
        this.hideApprovals =
          cu.roles.includes('MyCustomHomes_Quote_Approver') ||
          cu.roles.includes('MyCustomHomes_OverrideApprover')
            ? false
            : true;
      }
    );
    this.subscription.add(currentUserSub);
  }

  ngOnInit(): void {
    const qRevisions = this.quoteRevisionInfoService._quoteRevisions$.subscribe(
      revisions => {
        this.quoteRevisions = revisions;
      }
    );
    this.subscription.add(qRevisions);

    const quoteSub = this.quoteInfoService.quote$.subscribe(x => {
      this.modelId = x.modelId;
      this.quoteId = x.quoteId;
    });
    this.subscription.add(quoteSub);
  }

  ngAfterViewInit() {
    const searchChanges = this.searchBox.changes.subscribe(x => {
      const showUserMenuSub = this.quoteInfoService.showUserMenu$.subscribe(
        y => {
          if (y === true && x.first) {
            this.search = Observable.fromEvent(
              x.first.nativeElement,
              'keyup'
            ).debounceTime(250);
            this.search.subscribe(x => (this.searchTerm = x.target.value));
          }
        }
      );
      this.subscription.add(showUserMenuSub);
    });
    this.subscription.add(searchChanges);
  }

  logOut() {
    let quote = this.applicationStateService.getQuote();
    this.quoteService.setLockQuoteStatusOnRedirectOrClose(
      quote.quoteId,
      false,
      Number(this.currentUser.cmhUserId)
    );
    this.currentUserService.removeUserTokenAndProfile();
    this.quoteInfoService.showUserMenu$.next(false);
  }

  checkForQuoteId(retailer: any) {
    let current = JSON.parse(atob(localStorage.getItem('CLU'))).retailerNumber;
    let newRetailer = retailer.retailerNumber;
    if (newRetailer !== current) {
      if (
        this.quoteId !== undefined ||
        this.quoteId !== null ||
        this.quoteId !== 0
      ) {
        this.currentUserService.changeRetailerModalViewStatus$.next(true);
        this.authDataService.tempRetailer$.next(retailer);
      } else {
        this.authDataService.tempRetailer$.next(retailer);
        this.authDataService.setRetailer();
      }
    } else {
      this.quoteInfoService.showUserMenu$.next(false);
    }
  }
  /// Sets the new pricing
  setPricingView(pricingView: number) {
    this.applicationStateService.setPricingView(pricingView);
    this.quoteInfoService.currentPricingView$.next(pricingView);

    if (this.currentUser !== undefined && this.currentUser !== null) {
      let userPricingView: UserPricingView = new UserPricingView();
      userPricingView.PricingView = pricingView;
      userPricingView.UserId = Number(this.currentUser.cmhUserId);
      userPricingView.UserPricingViewId = 0;

      this.userPricingViewService
        .saveUserPricingView(userPricingView)
        .subscribe();
    }
  }

  navigate(url) {
    if (url === 'set-markup') {
      if (this.modelId) {
        this.quoteInfoService.showUserMenu$.next(false);
        this.router.navigate([url, this.quoteId]);
      }
    } else if (url === 'quote-history') {
      if (this.modelId) {
        this.quoteInfoService.showUserMenu$.next(false);
        if (
          this.applicationStateService.pricingView === 1 &&
          !window.location.href.includes('quote-history')
        ) {
          this.auditHistoryService.showQuoteHistoryModal$.next(true);
        } else {
          this.auditHistoryService.showQuoteHistoryModal$.next(false);
          this.router.navigate([url, this.quoteId]);
        }
      }
    } else if (url === 'quote-compare') {
      this.quoteInfoService.showUserMenu$.next(false);
      this.router.navigate([url, this.quoteId]);
    } else {
      window.location.href = `${this.cmhBaseUrl}/#!${url}`;
    }
  }

  navOptionsAdmin() {
    this.quoteInfoService.showUserMenu$.next(false);
    if (
      this.currentUser !== undefined &&
      this.currentUser !== null &&
      this.currentUser.cmhUserId !== undefined
    ) {
      window.location.href = `${this.mchBaseUrl}/options-admin/${Number(
        this.currentUser.cmhUserId
      )}`;
    } else {
      window.location.href = `${this.mchBaseUrl}/options-admin/0`;
    }
  }

  navQuoteApprovals() {
    this.quoteInfoService.showUserMenu$.next(false);
    if (
      this.currentUser !== undefined &&
      this.currentUser !== null &&
      this.currentUser.cmhUserId !== undefined
    ) {
      window.location.href = `${this.mchBaseUrl}/quote-approvals/${Number(
        this.currentUser.cmhUserId
      )}`;
    } else {
      window.location.href = `${this.mchBaseUrl}/quote-approvals/0`;
    }
  }

  get showQuoteSpecificStuff(): boolean {
    return !window.location.href.includes('options-admin') &&
      !window.location.href.includes('quote-approval') &&
      this.isMCHUser()
      ? true
      : false;
  }

  showQuoteCompare(): boolean {
    if (
      this.quoteRevisions &&
      this.quoteRevisions.length >= 2 &&
      !window.location.href.includes('quote-compare')
    ) {
      return true;
    }
    return false;
  }

  closeMenu() {
    const showUserMenuSub = this.quoteInfoService.showUserMenu$
      .take(1)
      .subscribe(x => {
        if (x === true) {
          this.authDataService.toggleUserModal();
        }
      });
    this.subscription.add(showUserMenuSub);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  isMCHUser(): boolean {
    let returnValue = false;
    if (this.currentUser.roles.length > 0) {
      if (
        this.currentUser.roles.filter(s => s.includes('MyCustomHomes')).length >
        0
      ) {
        returnValue = true;
      }
    }

    return returnValue;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/reusable-components/yeti-title-bar/yeti-title-bar.component.ts